import React,{Component} from 'react';
import {
    View,
  
    StyleSheet,
    Image,
    Platform,
    TouchableOpacity,
    TouchableWithoutFeedback,
    Linking
} from 'react-native';
import { Button, Card, Surface } from "react-native-paper";
import { imageBaseUrl } from './../../store/constants/apiConstants';
import moment from 'moment';
import {Text, Styles} from "./../../components/UI-Components";
import AdsScreen from './../Ads';
import {HoverComponent} from './'
import { withRouter } from 'react-router-dom';


class CurrentAffairs extends Component{

    constructor(props){
        super(props);
        //any thing can write here
    }

    handleClick = (url) => {
        Linking.canOpenURL(url).then(supported => {
          if (supported) {
            Linking.openURL(url);
          } 
        });
      };

    render(){       
        const { currentAffairs, fromList } = this.props;
        return(
            <>
            {
                !fromList ? (
                    <View style={{marginHorizontal:12,}}>
                    <View>
                    {
                           currentAffairs && currentAffairs.length && currentAffairs.map((item,index)=>{
                                return(
                                    <HoverComponent>
                                <TouchableWithoutFeedback                             
                                key={index}
                                onPress={() =>{
                                    if(fromList){
                                        this.props.history.push(`/CurrentAffairsList/${item.id}`, {
                                            data: item.content,
                                            id: index,
                                            titleId: item.id,
                                            source: item.url,                                            
                                        });
                                        return null;
                                    }
                                    this.props.navigation.push(`CurrentAffairs/${item.id}`, {
                                       data: item.content,
                                       id: index,
                                       titleId: item.id,
                                       source: item.url,                                       
                                   })
                                }
                                }>
                                    <Surface style={styles.card_shadow}>
                                        <Card.Actions>
                                            <View style={{flex:1,justifyContent:'flex-start',alignItems:'flex-start'}}>
                                            {/* <Text style={{color:Styles.primaryColor, fontSize:12,marginLeft:10,marginTop:10}}>Latest news</Text> */}
                                                <Text ellipsizeMode="tail" numberOfLines={3} style={styles.currentAffairscontent}>
                                                    {item.title}
                                                </Text>
                                                <View style={{flexDirection:'row',alignItems:'center',marginTop:10}}>
                                                    <Text style={{marginLeft:10,fontSize:10,color:'#707070'}}> { moment(item.created_at).format('D MMM YY') } </Text>
                                                </View>
                                            </View>
                                            <View style={{width:100, height:100}}>
                                                 <Image source={{uri:item.url}} style={styles.ImageStyle}/>
                                            </View>
                                        </Card.Actions>
                                    </Surface>
                                </TouchableWithoutFeedback>
                                </HoverComponent>
                                )
                            })
                        }
                    </View>
                        <View style={{justifyContent:'center',alignItems:'center', marginVertical:10}}>
                            <View >
                            {/* <TouchableWithoutFeedback
                            onPress= { () => {
                                alert()
                                return;
                                // this.handleClick('https://iaseasy.in/')
                            }}
                            style={{flexDirection:'row'}}>
                                <Text style={{color:'#0D47A1',fontSize:15}}>Moredd</Text>
                                    <View style={{marginLeft:5}}>
                                        <Icon 
                                        name={"ios-arrow-round-down"}
                                        size={20}
                                        color={"#0D47A1"}
                                        />
                                    </View>
                            </TouchableWithoutFeedback> */}
                            </View>
                        </View>
                {
                    this.props.adsTrue &&
                    <View style={{marginTop: 30}}>
                        <AdsScreen screenName={'CurrentAffairs'} />
                    </View>
                }
                </View>                               
                ) : (
                    <View style={{marginHorizontal:12,}}>
                    <View>
                  
                                <TouchableWithoutFeedback                             
                                // key={index}
                                onPress={() =>{
                                    // if(fromList){
                                        this.props.history.push(`CurrentAffairs/${currentAffairs.id}`, {
                                            data: currentAffairs.content,
                                            id:  currentAffairs.id,
                                            titleId: currentAffairs.id,
                                            source: currentAffairs.url,
                                            
                                        });
                                        // return;
                                    // }
                                //     this.props.navigation.navigate('CurrentAffairs', {
                                //        data: currentAffairs.content,
                                //        id: currentAffairs.id,
                                //        titleId: currentAffairs.id,
                                //        source: currentAffairs.url,
                                       
                                //    })
                                }
                                }>
                                    <Surface style={styles.card_shadow}>
                                        <Card.Actions>
                                            <View style={{flex:1,justifyContent:'flex-start',alignItems:'flex-start'}}>
                                            {/* <Text style={{color:Styles.primaryColor, fontSize:12,marginLeft:10,marginTop:10}}>Latest news</Text> */}
                                                <Text ellipsizeMode="tail" numberOfLines={3} style={styles.currentAffairscontent}>
                                                    {currentAffairs.title}
                                                </Text>
                                                <View style={{flexDirection:'row',alignItems:'center',marginTop:10}}>
                                                    <Text style={{marginLeft:10,fontSize:10,color:'#707070'}}> { moment(currentAffairs.created_at).format('D MMM YY') } </Text>
                                                </View>
                                            </View>
                                            <View style={{width:100, height:100}}>
                                                 <Image source={{uri:currentAffairs.url}} style={styles.ImageStyle}/>
                                            </View>
                                        </Card.Actions>
                                    </Surface>
                                </TouchableWithoutFeedback>
                          
                        
                    </View>
                        <View style={{justifyContent:'center',alignItems:'center', marginVertical:10}}>
                            <View >
                            {/* <TouchableWithoutFeedback
                            onPress= { () => {
                                alert()
                                return;
                                // this.handleClick('https://iaseasy.in/')
                            }}
                            style={{flexDirection:'row'}}>
                                <Text style={{color:'#0D47A1',fontSize:15}}>Moredd</Text>
                                    <View style={{marginLeft:5}}>
                                        <Icon 
                                        name={"ios-arrow-round-down"}
                                        size={20}
                                        color={"#0D47A1"}
                                        />
                                    </View>
                            </TouchableWithoutFeedback> */}
                            </View>
                        </View>
                {
                    this.props.adsTrue &&
                    <View style={{marginTop: 30}}>
                        <AdsScreen screenName={'CurrentAffairs'} />
                    </View>
                }
                </View>   
                )
            }
           
            </>
        ) 
    }
}

const styles = StyleSheet.create({
    heading:{
        fontSize:20,
        color:'#222',
        paddingLeft: 10,
        marginVertical:20,
        
    },
    currentAffairsDescription:{
        alignItems:'center',
        justifyContent:'center',
        marginHorizontal:10
    },
    ImageStyle:{
        justifyContent:'center',
        alignItems:'center',
        marginTop:10,
        width:100,
        height:80,
        resizeMode:'contain',
        // backgroundColor:Color.imageBgColor,
        borderRadius:2
    },
    currentAffairscontent:{
        // height:70,
        paddingHorizontal:10,
        paddingTop:2,
        textAlign:'justify',
        // borderWidth: 1,
        marginTop: -5,
        fontWeight: 'bold'
    },
    card_shadow:{
    marginVertical:4,
    // backgroundColor:'#fcfcfc',
    // shadowColor: '#000',
    // shadowOffset: { width: 0, height: 1 },
    // shadowOpacity: 0.4,
    // shadowRadius: 1.5,
    elevation: 8,
    borderRadius:10
    
    }
})

export default withRouter(CurrentAffairs);
